const Categories = [
  { text: 'Inside', value: 3 },
  { text: 'Outside', value: 4 },
  { text: 'Engine Compartment', value: 5 },
  { text: 'Underneath', value: 6 }
]
export { Categories }